import { NgModule } from '@angular/core';

import { WindowRef } from '../../services/window-ref/window-ref.service';

@NgModule({
  imports: [],
  declarations: [],
  providers: [WindowRef],
  exports: [],
})
export class WindowRefModule {}
